import PageHeader from '../reusable/PageHeader';
import { USER_ROLES, NAVIGATION_LINKS_DATA } from '../../constants';
import useUserDetails from '../hooks/useUserDetails';
import Loader from '../reusable/Loader';
import { DistrictDataLeadView } from './OverviewContent';
import { Navigate } from 'react-router-dom';

import './Overview.css';

function Overview() {
  const {
    userDetails: { isPending, error, data: userDetails },
  } = useUserDetails();

  if (isPending) return <Loader />;
  if (error || !userDetails) return <p className="center-text">Missing user details data!</p>;

  if (userDetails.role === USER_ROLES.LEAD_FACILITATOR || userDetails.role === USER_ROLES.FACILITATOR) {
    return <Navigate to={NAVIGATION_LINKS_DATA.DASHBOARD.path} />;
  }

  return (
    <>
      <PageHeader title={NAVIGATION_LINKS_DATA.OVERVIEW.label} pageDescription="Review your progress on EOAA tasks" />
      <div className="main-content">
        {userDetails.role === USER_ROLES.DISTRICT_DATA_LEAD || userDetails.role === USER_ROLES.XQ_ADMIN ? (
          <DistrictDataLeadView userDetails={userDetails} />
        ) : null}
      </div>
    </>
  );
}

export default Overview;
